import * as React from 'react';
import { st, classes } from './ErrorMessageWrapper.st.css';
export var ErrorMessageWrapper = function (props) {
    var render = props.render, error = props.error, disabled = props.disabled, errorMessage = props.errorMessage, className = props.className;
    var inErrorState = error && !disabled && !!errorMessage;
    return (React.createElement("div", { className: st(classes.root, className), "data-hook": props['data-hook'] },
        render({ error: inErrorState }),
        inErrorState && (React.createElement("div", { className: classes.errorMessage }, errorMessage))));
};
//# sourceMappingURL=ErrorMessageWrapper.js.map